<template>
  <v-autocomplete
      ref="buscador"
      v-model="busqueda"
      :items="productosCategoriasTiendas"
      :loading="isLoading"
      :search-input.sync="search"
      hide-details
      hide-selected
      prepend-inner-icon="mdi-magnify"
      item-text="Descripcion"
      item-value="Id"
      :label="label"
      solo
      :no-data-text="noDataText"
      return-object
      clearable
      single-line
      class="ma-4"
      :filter="customFilter"
      v-show="showBuscador"
    >
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title>{{ item.Descripcion }}</v-list-item-title>
          <v-list-item-subtitle v-if="esCategoria(item)">Categoría</v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
</template>
<script>
import { mapActions } from 'vuex'
import clientCode from '@/helpers/getClientCode'

export default {
  name: 'Buscador',
  computed: {
    showBuscador () {
      return this.$route.name !== 'Sucursales' && this.$route.name !== 'Checkout' && this.$route.name !== 'PageNotFound' && this.$route.name !== 'VerPedido'
    },
    productosCategoriasTiendas () {
      return this.items
    },
    label () {
      return this.labelTexts[this.$route.name] || '¿Qué querés buscar?'
    },
    noDataText () {
      return this.noDataTexts[this.$route.name] || 'No se encontraron resultados'
    }
  },
  data () {
    return {
      items: [],
      search: null,
      busqueda: null,
      isLoading: false,
      labelTexts: {
        Tiendas: '¿Que tienda querés buscar?',
        Categorias: '¿Que querés buscar?',
        Home: '¿Que querés buscar?',
        HomeShort: '¿Que querés buscar?',
        ProductosMobile: '¿Que producto querés buscar?',
        Producto: '¿Que producto querés buscar?'
      },
      noDataTexts: {
        Tiendas: 'No se encontraron tiendas',
        Categorias: 'No se encontraron productos o categorías',
        Home: 'No se encontraron productos o categorías',
        HomeShort: 'No se encontraron productos o categorías',
        ProductosMobile: 'No se encontraron productos',
        Producto: 'No se encontraron productos'
      }
    }
  },
  methods: {
    ...mapActions('Categorias', ['getCategoriasProductos', 'searchTiendas']),
    esCategoria (item) {
      const tipo = String((item && (item.Tipo || item.tipo)) || '').toLowerCase()
      return tipo === 'categoria' || tipo === 'categorias'
    },
    irACategoria (id) {
      const client = clientCode()
      const mesaId = this.$route.params && this.$route.params.mesaId
      const enCatalogo = ['Home', 'HomeShort', 'MesaQR'].includes(this.$route.name)
      const query = enCatalogo
        ? { ...(this.$route.query || {}), categoria: String(id) }
        : { categoria: String(id) }
      if (mesaId) {
        this.$router.push({
          name: 'MesaQR',
          params: { client, mesaId: String(mesaId) },
          query
        }).catch(() => {})
        return
      }
      const name = this.$route.name === 'HomeShort' ? 'HomeShort' : 'Home'
      this.$router.push({ name, params: { client }, query }).catch(() => {})
    },
    ejecutarNavegacion (sel) {
      if (!sel || typeof sel !== 'object') return
      const tipo = String(sel.Tipo || sel.tipo || '').toLowerCase()
      const id = sel.Id ?? sel.id
      const code = sel.Code ?? sel.code
      this.busqueda = null
      this.search = null
      this.$nextTick(() => {
        if (this.$refs.buscador && this.$refs.buscador.internalSearch != null) {
          this.$refs.buscador.internalSearch = null
        }
      })
      const esCategoria = tipo === 'categoria' || tipo === 'categorias'
      const esTienda = tipo === 'tienda' && code
      if (esCategoria && id != null) {
        this.irACategoria(id)
      } else if (id != null && !esTienda) {
        const client = clientCode()
        this.$router.push({ name: 'Producto', params: { id: String(id), client } })
      } else if (esTienda) {
        const path = `/tienda/${code}`
        this.$router.push({ path })
      }
    },
    customFilter (item, queryText, itemText) {
      return item
    }
  },
  watch: {
    busqueda (nuevo) {
      if (nuevo && typeof nuevo === 'object' && (nuevo.Tipo || nuevo.tipo || nuevo.Id != null || nuevo.id != null)) {
        this.$nextTick(() => this.ejecutarNavegacion(nuevo))
      }
    },
    async search (val) {
      const query = val != null ? String(val).trim() : ''
      if (query === '') {
        this.items = []
        return
      }
      switch (this.$route.name) {
        case 'Tiendas':
          this.isLoading = true
          const tiendas = await this.searchTiendas(query)
          this.items = Array.isArray(tiendas) ? tiendas : []
          this.isLoading = false
          break
        case 'Home':
        case 'HomeShort':
        case 'ProductosMobile':
        case 'Producto':
        case 'Categorias':
          this.isLoading = true
          const productos = await this.getCategoriasProductos(query)
          this.items = Array.isArray(productos) ? productos : []
          this.isLoading = false
          break
        default:
          if (this.$route.params && this.$route.params.client) {
            this.isLoading = true
            const def = await this.getCategoriasProductos(query)
            this.items = Array.isArray(def) ? def : []
            this.isLoading = false
          }
          break
      }
    }
  }
}
</script>
